module.exports = __webpack_public_path__ + "static/images/icon-arrow-right.d4a1b301b0c83534b429dffbe5c450ea.svg";